import { CreateCompanyActionsEnum, ICreateCompany, ICreateUser } from './types'

export const actions = {
  setCurrentStep: (payload: string) => ({
    type: CreateCompanyActionsEnum.setCurrentStep,
    payload,
  }),
  setCreateCompanyDetails: (payload: ICreateCompany) => ({
    type: CreateCompanyActionsEnum.setCreateCompanyDetails,
    payload,
  }),
  setCreateUser: (payload: ICreateUser) => ({
    type: CreateCompanyActionsEnum.setCreateUser,
    payload,
  }),
  isCreateCompanyLoader: (payload: boolean) => ({
    type: CreateCompanyActionsEnum.isCreateCompanyLoader,
    payload,
  }),
  setCreateUserName: (payload: string) => ({
    type: CreateCompanyActionsEnum.setCreateUserName,
    payload,
  }),
  setFlow: (payload: string) => ({
    type: CreateCompanyActionsEnum.setFlow,
    payload,
  }),
  setPlan: (payload: string) => ({
    type: CreateCompanyActionsEnum.setPlan,
    payload,
  }),
}
